import BaseModel from '@/app-core/lib/data/model/BaseModel'
import CustomerAddressValidator from '@/app-core/api/validations/customer/CustomerAddressValidator'
import CustomerAddressResource from '@/app-core/api/resources/customer/CustomerAddressResource'
import DataEventService from '@/app-core/lib/services/event/DataEventService'
import DataEventEnum from '@/app-core/lib/services/enum/DataEventEnum'
import API from '@/app-core/api/Api'

export default class CustomerAddressModel extends BaseModel {
  constructor(payload = {}, resource = CustomerAddressResource, validator = CustomerAddressValidator, vueComponentInstance) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = ['useCustomAddress']
  }

  /* PROPERTIES */

  /* METHODS */
  async UpdateOrCreate() {
    const payload = this.clone()

    payload.CustomerId = this.vueInstance?.user?.Info?.Id || null
    payload.Formatted = this.getAddressFormatted()
    if (this.useCustomAddress) payload.Lat = payload.Lng = 0

    DataEventService.Emit(DataEventEnum.EVENT, {
      Event  : this.Id ? DataEventEnum.ACCOUNT_UPDATE_ADDRESS : DataEventEnum.ACCOUNT_ADD_ADDRESS,
      Payload: this.clone()
    })

    return await API.Resource.Account.AddressSave(payload)
  }

  async Delete() {
    const payload = {
      Id        : this.Id,
      CustomerId: this.vueInstance?.user?.Info?.Id || null
    }

    DataEventService.Emit(DataEventEnum.EVENT, {
      Event  : DataEventEnum.ACCOUNT_DELETE_ADDRESS,
      Payload: this.clone()
    })

    return await API.Resource.Account.AddressDelete(payload)
  }

  getAddressFormatted(withCountry = false) {
    const country = this.Country || this.CountryCode || ''
    const numberSeparator = this.Street ? ' ' : ''
    const citySeparator = this.Street || this.Number ? ', ' : ''
    const postcodeSeparator = this.Street || this.Number || this.City ? ' ' : ''
    const countrySeparator = this.Street || this.Number || this.City || this.Postcode ? ', ' : ''

    let retVal = ''
    retVal += this.Street ? this.Street : ''
    retVal += this.Number ? numberSeparator + this.Number : ''
    retVal += this.City ? citySeparator + this.City : ''
    retVal += this.Postcode ? postcodeSeparator + this.Postcode : ''
    retVal += this && withCountry ? countrySeparator + country : ''

    return retVal
  }
}
